import HttpService from './HttpService';
const API_ENDPOINT = '/payroll/salary-slip';

const SalarySlipsService = {
  async getSalarySlips(payrollId) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/employees/${payrollId}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async getEmployeeWiseSalarySlips(empId) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/employee/${empId}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async viewSalarySlip(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/view/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async viewUserSalarySlip(id) {
    try {
      const response = await HttpService.get(`${API_ENDPOINT}/user/${id}`);
      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },
  async bulkDownloadSalarySlips(data) {
    try {
      const response = await HttpService.post(`${API_ENDPOINT}/bulk-download`, data, {
        headers: {
          "Content-Type": "application/json",
          Accept: "application/zip",
        },
        responseType: 'arraybuffer',
      });      return response.data;
    } catch (error) {
      throw error.response.data;
    }
  },

};

export default SalarySlipsService;